import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

/** Indeterminate circular spinner (replaces PrimeNG p-progressspinner). */
@Component({
  selector: 'app-spinner',
  imports: [],
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SpinnerComponent {
  @Input() size = '2rem';

  @HostBinding('class')
  readonly hostClass = 'inline-block animate-spin rounded-full border-[3px] border-slate-200 border-t-[var(--tenant-accent)] dark:border-slate-600 dark:border-t-[var(--tenant-accent)]';

  @HostBinding('style.width') get w(): string {
    return this.size;
  }

  @HostBinding('style.height') get h(): string {
    return this.size;
  }

  @HostBinding('attr.role') readonly role = 'status';
  @HostBinding('attr.aria-label') readonly label = 'Loading';
}
